// URL base del motor de reservas directas (book), SANEADA.
//
// dotenv (Vue CLI) NO recorta comentarios "inline" escritos en la misma línea que el
// valor de una variable. Si en el .env queda un comentario pegado al valor de
// VUE_APP_BOOK, ese texto se cuela DENTRO del valor y rompe TODOS los enlaces del motor
// (base + comentario + "/booking/..."). Este helper corta cualquier comentario, espacios
// y barras finales para que el enlace salga siempre limpio, pase lo que pase en el .env.
export function bookBase() {
  const raw = process.env.VUE_APP_BOOK || "https://book.wacheckin.com";
  return String(raw)
    .split("#")[0]        // corta comentario inline pegado al valor
    .trim()               // espacios sobrantes
    .replace(/\/+$/, ""); // barra(s) final(es)
}

export default bookBase;
